module.exports = __webpack_public_path__ + "img/latest-article-cover.d71e1952.png";